import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@guildeducationinc/recess';
import { useAuth } from '@src/hooks/useAuth';
import { ContainerContext } from '@src/contexts';
import { TrackableButton, useLocale } from 'pe-core-frontend';
import { useNavigate } from 'react-router-dom';
import { useEffect, useContext } from 'react';
function LinkSection({ section, links }) {
    const { t } = useLocale();
    return (_jsxs("section", { className: 'mt-2', children: [_jsx(Typography, { variant: 'h2', children: t(section) }), links.map((link, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            _jsx("div", { className: 'm-4', children: _jsx(TrackableButton, { btnType: 'link', enText: link.text, tag: `site_map-${link.tag}`, href: link.href, onClick: link.onClick, target: link.openNewWindow ? '_blank' : undefined, rel: link.openNewWindow ? 'noopener noreferrer' : undefined, children: t(link.text) }) }, idx)))] }));
}
export const SiteMap = () => {
    const { setShowFooter } = useContext(ContainerContext);
    const navigate = useNavigate();
    const { t } = useLocale();
    const { logout } = useAuth();
    useEffect(() => {
        setShowFooter(true);
    }, []);
    const accountLinks = [
        {
            text: 'Login / Sign up',
            href: 'login',
            tag: 'login',
        },
        {
            text: 'Log out',
            tag: 'logout',
            href: '.',
            onClick: async () => {
                await logout();
                return navigate('/login');
            },
        },
        {
            text: 'Home',
            href: '.',
            tag: 'home',
        },
        {
            text: 'Profile',
            href: 'profile',
            tag: 'profile',
        },
    ];
    const requestLinks = [
        {
            text: 'Activity',
            href: 'activity',
            tag: 'activity',
        },
        {
            text: 'New request',
            href: 'requests',
            tag: 'requests',
        },
    ];
    const resourceLinks = [
        {
            text: 'About benefit',
            href: 'reimbursement-policy',
            tag: 'reimbursement-policy',
        },
        {
            text: 'Contact support',
            href: 'support',
            tag: 'support',
            openNewWindow: true,
        },
        {
            text: 'Terms',
            href: 'https://guild.com/terms-of-use',
            tag: 'terms',
            openNewWindow: true,
        },
        {
            text: 'Privacy',
            href: 'https://guild.com/privacy-policy',
            tag: 'privacy',
            openNewWindow: true,
        },
    ];
    return (_jsxs("div", { className: 'ml-4', children: [_jsx(Typography, { variant: 'h1', children: _jsx("div", { className: 'mt-8 mb-8', children: t('Site map') }) }), _jsx(LinkSection, { section: 'Account', links: accountLinks }), _jsx(LinkSection, { section: 'Requests', links: requestLinks }), _jsx(LinkSection, { section: 'Resources', links: resourceLinks })] }));
};
